'use client'

import { resolveAuthenticatedWsUrl } from '@/lib/websocket'
import { toSameOriginCompilerWsUrl } from '@/lib/compiler/same-origin-ws'

/**
 * Build a CRDT WebSocket URL on the page origin, with optional auth.
 * Loopback `next dev` may then be pointed at COMPILER_WS_URL.
 * A public page stays on that page origin. The Next.js rewrite proxies
 * `/compiler/api/v1/crdt/ws/` to the compiler when the upgrade reaches this process.
 */
export async function resolveAuthenticatedCrdtWsUrl(wsPath: string): Promise<string> {
  const baseUrl = toSameOriginCompilerWsUrl(wsPath)
  return resolveAuthenticatedWsUrl(baseUrl)
}
